import { render, staticRenderFns } from "./vedioSet.vue?vue&type=template&id=474ec7ea&scoped=true&"
import script from "./vedioSet.vue?vue&type=script&lang=js&"
export * from "./vedioSet.vue?vue&type=script&lang=js&"
import style0 from "./vedioSet.vue?vue&type=style&index=0&id=474ec7ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474ec7ea",
  null
  
)

export default component.exports